import { OptionsTranslations } from "./optionsTranslations.types";

import {
    getCgvLink,
    getDataRightsLink,
    getPrivacyPolicyLink,
} from "@/service/legalLinks/legalLinksService";

const cgvUrl = getCgvLink();
const dataRightsLink = getDataRightsLink("nl");
const privacyPolicyLink = getPrivacyPolicyLink("nl");

const optionsNlTranslations: OptionsTranslations = {
    optionsPage: {
        "title": "Extra’s",
        "step": "STAP",
        "optionsExtraTitle": "Personaliseer je reis",
        invalidLastNameError: 'Vul een geldige achternaam in, minimaal 2 tekens',
        optionsChangeModalErrorAgeChange: "Door leeftijdsveranderingen van een van de deelnemers zijn de prijzen en beschikbaarheid van bepaalde opties gewijzigd. Hier zijn de wijzigingen.",
        optionsChangeModalContinue: "Doorgaan",
        invalidDateError: 'Vul uw geboortedatum in',
        invalidFirstNameError: 'Vul een geldige voornaam in, minimaal 2 tekens',
        hasFirstParticipantToBeAdultError: 'De eerste deelnemer moet meerderjarig zijn',
        hasToBeAdultError: 'Deelnemer moet meerderjarig zijn',
        accommodationExceedsAdultsError: 'Het aantal geselecteerde accommodaties kan niet groter zijn dan het aantal volwassenen in uw groep. Pas uw selectie aan.',
        accommodationCount: 'Aantal accommodaties',
        adultCount: 'Aantal volwassenen',
        invalidParticipantError: "Vul de gegevens van deze deelnemer in",
        optionsModify: "Aanpassen",
        optionsModifyPanel: "Wijzig",
        optionsPanelTitleModify: "Wijzig",
        optionsPanelTitleModifyLa: "Wijzig",
        optionsPanelTitleModifyFor1: "Wijzig",
        optionsPanelTitleModifyFor2: "van",
        optionsAdd: "Toevoegen",
        optionsIncluded: "Inbegrepen",
        optionsDay: "dag",
        optionsDays: "dagen",
        optionsDays2: "dagen",
        optionsFrom: "van",
        optionsTo: "t/m",
        optionsValidateSelection: "Mijn keuze bevestigen",
        validateForAllParticipants: "Bevestig mijn selectie voor alle deelnemers",
        optionsRemoved: "is verwijderd uit pakket",
        optionsErrorSorry: "Helaas,",
        optionsErrorDefaultService: "deze service",
        optionsErrorNotAvailable: "is niet langer beschikbaar.",
        optionsNoServiceSelected: "Geen dienst geselecteerd",
        optionsNoServiceSelected1: "",
        optionsNoServiceSelected2: "",
        optionsNoSkipass: "Geen skipas geselecteerd",
        optionsNoEquipment: "Geen ski-/snowboard materiaal geselecteerd",
        optionsNoTransport: "Geen vervoer geselecteerd",
        optionsNoEsf: "Geen ski-/snowboardlessen geselecteerd",
        optionsVirtualNoEsf: "Geen ski-/snowboardlessen",
        optionsNoFood: "Geen maaltijd geselecteerd",
        optionsNoInsuranceSkier: "Geen verzekering geselecteerd",
        optionsNoHotelService: "Geen extra diensten geselecteerd",
        options15Cancellation: "Gratis annuleren tot 15 dgn voor aankomst m.u.v. boekingen Pierre & Vacances + Events dan ANVR voorwaarden",
        options45Cancellation: "Gratis 100% annuleren tot 40 dgn voor aankomst, m.u.v. Events dan ANVR voorwaarden*",
        options45CancellationUnderSentence: "*Voor meer informatie, raadpleeg onze Algemene Voorwaarden",
        optionsWhoDeparts: "Reizigers",
        optionsPleaseFillParticipants: "Vul de namen en leeftijden (op aankomstdatum) van alle deelnemers in.",
        widgetAllParticipantsRequired: "Sla elke deelnemer op (knop Opslaan op elke kaart) voordat u verdergaat.",
        widgetContactInvalid: "Voer een geldig e-mailadres en telefoonnummer in.",
        widgetRegisterFailed: "Account aanmaken mislukt. Probeer het opnieuw of gebruik een ander e-mailadres.",
        widgetTransportConfigureTitle: "Stel uw vervoer in",
        widgetJourneyDetailsTitle: "Reisdetails",
        widgetOrderRecapTitle: "Overzicht van de bestelling",
        widgetTrainOutboundColumn: "Trein heen",
        widgetTrainReturnColumn: "Trein terug",
        widgetNoReturnTrain: "—",
        optionsFillNames: "Vul de namen en leeftijden van alle deelnemers en profiteer van de beste prijzen.",
        optionsParticipant: "Reiziger",
        optionsYears: "jaar",
        optionsYearsAndMore: "en ouder",
        optionsAgeAtStart: "Leeftijd bij aanvang van de reis",
        optionsFirstName: "Voornaam",
        optionsLastName: "Achternaam",
        optionsTravelersErrorMessage: "Vul de voor- en achternaam en de leeftijd van elke reiziger in",
        optionsPrepareYourVoyage: "Pas je reis aan",
        optionsSelectYourInsurances: "Selecteer verzekering",
        optionsChangeTravelerAge: "Het wijzigen van de leeftijd van de reiziger zal al zijn/haar opties resetten.",
        optionsChangeTravelerAgeConfirmation: "De leeftijd van de volgende reiziger(s) is bijgewerkt. Al hun opties zijn gereset.",
        optionsChangeTravelerAgeUpdated: "Deelnemersinformatie is bijgewerkt",
        optionsIUnderstood: "Begrepen",
        optionsSkipass: "Skipas",
        optionsNoSkipassSelected: "Geen skipas geselecteerd",
        optionsKmSkiSlopes: "km pistes",
        optionsOfTracks: "pistes",
        optionsRemoveSkipass1: "Als je deze optie uit je pakket haalt, blijft er een bedrag van",
        optionsRemoveSkipass2: "over",
        optionsNoQueues: "Bij het inchecken ontvang je naast je sleutels ook direct je geboekte skipassen",
        optionsSkipassBlueSentence: "Bespaar tijd en geld",
        optionsEquipment: "Skimateriaal",
        optionsSelectLevel: "Kies categorie",
        criteria997: "Eco",
        criteria998: "Zilver",
        criteria999: "Goud",
        criteria1000: "Platinum",
        criteria1031: "Espoir",
        criteria1030: "Champion",
        optionsNoEquipmentSelected: "Geen ski-/snowboard materiaal geselecteerd",
        optionsEnjoySkiingAtArrival1: "Haal je uitrusting op bij de skishop",
        optionsEnjoySkiingAtArrival2: "gelegen op",
        optionsEnjoySkiingAtArrival3: "meter van je accommodatie",
        optionsHelmet: "Skihelm",
        optionsShoes: "Skischoenen",
        optionsSticks: "Skistokken",
        optionsEquipmentBlueSentence: "Dichtbij en eenvoudig",
        optionsTransport: "Vervoer",
        optionsTransfer: "Transfer",
        optionsEnjoySkiingAtArrival: "Profiteer van skiën/snowboarden direct bij aankomst!",
        optionsDistanceFromSkiShop1: "De skishop",
        optionsDistanceFromSkiShop2: "bevindt zich op",
        optionsDistanceFromSkiShop3: "van je accommodatie",
        optionsDistanceFromSkiShop4: "bevindt zich in hetzelfde gebouw als uw accommodatie!,",
        optionsPickupEquipmentAtShop: "Haal uw materiaal op in de winkel",
        optionsAddTransport: "Vervoer toevoegen",
        optionsAddTransportFor: "Voeg vervoer toe voor",
        optionsDeleteTransport: "Vervoer verwijderen",
        optionsTransportFirstDate: "Ga naar",
        optionsTransportSecondDate: "Terug",
        optionsPackageTravelski: "Travelski Pakket:",
        optionsTrainPlusShuttle: "trein + shuttle.",
        optionsNoTransportSelected: "Geen vervoer geselecteerd",
        optionsChooseAGo: "Kies heenreis",
        optionsChooseAReturn: "Kies terugreis",
        optionsDeparture: "Vertrek",
        optionsReturn: "Terug",
        optionsDepartureStation: "Opstapplaats bij heenreis",
        optionsArrivalStation: "Uitstapplaats bij heenreis",
        optionsOneWayOption: "Opties",
        optionsITravelIn: "Ik reis met:",
        optionsMyTransfer: "Mijn transfe",
        optionsTransportSummaryFor: "Overzicht van vervoer voor",
        optionsTotalTransport: "Totaal vervoer",
        optionsTransitTime: "",
        optionsEstimatedTime: "",
        optionsInformation: "Informatie",
        train: "",
        criteria1039: "1e klas",
        criteria1040: "2e klas",
        shuttle: "Shuttle",
        taxi: "Taxi",
        baggageCabin: "Handbagage",
        backpack: "Rugzak",
        wifi: "Wifi",
        meal: "Maaltijd",
        dinner: "Diner",
        optionsHowToChooseTitle: "Hoe kies ik een skiles die past bij mijn niveau?",
        optionsSkiLesson: "Skilessen",
        optionsTakeEsf: "Selecteer ski-/snowboardlessen",
        optionsCourseOn: "Ski-/snowboardlessen op",
        optionsHowIChooseLesson: "Kies een les die past bij jouw skiniveau",
        optionsBeginner: "Beginner",
        optionsPiouPiou: "Piou-Piou",
        criteria992: "Ourson",
        criteria993: "Flocon",
        criteria994: "1e ster",
        criteria995: "2e ster",
        criteria996: "3e ster",
        criteria1058: "Niv. 0",
        criteria1059: "Niv. 1",
        criteria1060: "Niv. 2",
        criteria1061: "Niv. 3",
        criteria1062: "Niv. 4",
        criteria1063: "Niv. 5",
        optionsNoCourseSelected: "Geen ski-/snowboardlessen geselecteerd",
        optionsContentPiouPiou: "Ik wil spelen in de sneeuw en voor de eerste keer glijden op ski’s.",
        optionsContentOursonTitle: "Ik ga voor het eerst skiën",
        optionsContentOurson: "Ik wil leren hoe ik mijn evenwicht bewaar, bochten maak met de pizzapunt, snelheid controleer en in de stoeltjeslift of sleeplift stap.",
        optionsContentFloconTitle: "Ik heb mijn Ourson behaald",
        optionsContentFlocon: "Ik maak snelle en lange bochten",
        optionsContent1StarTitle: "Ik heb mijn Flocon behaald",
        optionsContent1Star: "Ik maak een pizzapunt en neem zelf een sleeplift",
        optionsContent2StarTitle: "Ik heb mijn eerste ster. Ik ski overal op blauwe pistes.",
        optionsContent2Star: "Ik maak mijn bochten parallel",
        optionsContent3StarTitle: "Ik heb mijn 2e ster behaald",
        optionsContent3Star: "Ik moet mijn parallelle bochten perfectioneren om controle te behouden als ik snel ga",
        optionsContentAdulteBeginnerTitle: "Ik ga voor het eerst skiën",
        optionsContentAdulteBeginner: "Ik wil leren hoe ik mijn evenwicht bewaar, bochten maak met de pizzapunt, snelheid controleer en in de stoeltjeslift of sleeplift stap.",
        optionsAdultsBeginner: "Volwassenen - beginnend skiër",
        optionsWatchVideo: "Bekijk de video",
        optionsBackToChoices: "Terug naar de keuzes van de reizigers",
        optionsAgeGroup1: "3 tot 4 jaar",
        optionsAgeGroup2: "4 tot 5 jaar",
        optionsAgeGroup3: "6 tot 12 jaar",
        optionsAgeGroup4: "13 jaar en ouder (Volwassenen)",
        optionsFood: "",
        optionsTakeFood: "",
        optionsTakeFoodFor: "",
        optionsCatering: "",
        optionsCateringDelivery: "",
        optionsNoFoodSelected: "",
        optionsSeeMenu: "Bekijk het menu",
        optionsRestaurant: "Restaurant",
        optionsCateringServices: "Catering naar jouw smaak",
        optionsRestaurationBord: "Catering aan boord",
        optionsRestaurationBordOutbound: "Catering aan boord - Heenreis",
        optionsRestaurationBordInbound: "Catering aan boord - Terugreis",
        optionsFacilitateArrival: "Faciliteer je aankomst door je diensten te reserveren",
        optionsReserveYourServices: "Reserveer je diensten",
        optionsTakeAccommodationServices: "Selecteer extra diensten",
        optionsBookServices: "Boek extra diensten",
        optionsBookServicesEasy: "Reserveer extra diensten om jouw aankomst te vergemakkelijken",
        optionsInsurance: "Verzekering",
        optionsTakeInsurance: "Kies reisverzekering",
        optionsNoInsuranceSelected: "Geen verzekering geselecteerd",
        optionsInsuranceAdvantages: "De voordelen van een reisverzekering",
        optionsPerPers: "pers",
        optionsBreakageTheft: "Schade en diefstal van persoonlijke of gehuurde ski-uitrusting",
        optionsRescueResearch: "Kosten voor zoek- en reddingsacties op de pistes",
        optionsHospitalization: "Kosten voor medische behandeling en ziekenhuisverblijf",
        optionsRepatriation: "Repatriëringskosten",
        optionsInterruptionStay: "Kosten voor onderbreking van het verblijf en terugbetalingen voor ongebruikte diensten",
        optionsSnowGuarantee: "Sneeuwgarantie",
        optionsInsuranceAnnulation: "Annuleringsverzekering",
        optionsPerBooking: "Boeking",
        optionsCancellation: "Annulering mogelijk tot de dag voor aankomst",
        optionsReimbursement: "Terugbetaling per bankoverschrijving voor ongeldige redenen",
        optionsCreditNote: "Dekt gevallen die niet door creditcards worden gedekt",
        optionsCoveragePrice: "Voucher 12 maanden geldig in geval van een niet-gerechtvaardigde reden",
        optionsInsuranceAnnulationNo: "Ik hoef geen verzekering",
        optionsInsuranceAnnulationYes: "Neem verzekering",
        optionsInsuranceSlogan: "Gedekt zijn tijdens het verblijf",
        optionsPerson: "volwassene",
        optionsFree: "Gratis",
        commercialDiscount: "Commerciële korting",
        moreInfos: "Meer info",
        seeLess: "Sluit",
        saveRegistration: "Opslaan",
        acceptConditions: "Ik heb de Algemene Voorwaarden en het Beleid voor Gegevensbeheer gelezen en accepteer deze.",
        optionSumbit: "Reserveren",
        yes: "Ja",
        no: "Nee",
        "optionsInsuranceAnnulationCallToAction": "Wil je een annuleringsverzekering afsluiten?",
        optionsSkiSchool: 'Skischool',
        optionsChangeModalTitle: "Wijzigingen in opties",
        optionsChangeModalDescription: "Door leeftijdsveranderingen van een van de deelnemers zijn de prijzen en beschikbaarheid van bepaalde opties gewijzigd. Hier zijn de wijzigingen.",
        optionsChangeModalSubtitle: "Opties gewijzigd door leeftijdsveranderingen",
        optionsChangeModalTotalDifference: "Totaal verschil:",
        optionsChangeModalDismiss: "Sluiten",
        optionsChangeModalNoChange: "Geen wijziging",
        optionsChangeModalNotAvailable: "Niet beschikbaar",
        optionsChangeModalOption: "Optie",
        optionsChangeModalChangesAgeFrom: "verandert leeftijd van",
        optionsChangeModalTo: "naar",
        optionsChangeModalTraveller: "Reiziger",
        optionsSkiInsurance: 'Skiërverzekering',
        enterPromocode: "Voer kortingscode in",
        promocode: "Kortingscode",
        promocodeWrong: "De kortingscode die je hebt ingevoerd is ongeldig",
        promocodeApplied: "Kortingscode succesvol toegepast",
        promocodeEmailRequired: "E-mail is vereist om deze kortingscode te gebruiken",
        promocodeEmailModalTitle: "Voer uw e-mailadres in",
        promocodeEmailPlaceholder: "Uw e-mailadres",
        promocodeEmailSubmit: "Verzenden",
        promocodeEmailCancel: "Annuleren",
        promocodeEmailInvalid: "Ongeldig e-mailformaat",
        promocodeRemoved: "Uw kortingscode is verwijderd",
        promocodeExternalValidationTitle: "Externe validatie vereist",
        promocodeExternalValidationProvider: "Provider",
        promocodeExternalValidationCancel: "Annuleren",
        promocodeExternalValidationSubmit: "Verzenden",
        promocodeExternalValidationFieldFirstname: "Voornaam",
        promocodeExternalValidationFieldLastname: "Achternaam",
        promocodeExternalValidationFieldBirthdate: "Geboortedatum",
        promocodeExternalValidationFieldLastSixDigits: "Laatste 6 cijfers",
        promocodeExternalValidationFieldRequired: "{{label}} is verplicht",
        promocodeExternalValidationFieldInvalidFormat: "Het formaat van {{label}} is ongeldig",
        promocodePrivateWarningTitle: "LET OP: Deze promotiecode is privé",
        promocodeDeleteCode: "Ik verwijder mijn code",
        promocodeValidate: "Ik bevestig",
        promocodePrivateWarningProof: "Let op, een **bewijs van lidmaatschap** voor [CSE NAME] kan bij aankomst worden gevraagd.",
        promocodeWarningTitle: "Let op",
        removePromocode: "Verwijder de code",
        optionFlightLuggage: "Vliegtuigbagage",
        optionsFlightLuggageHoldBag: "Extra bagage",
        optionsFlightLuggageUnderSeatBag: "Handbagage - 10kg",
        optionsFlightLuggageUnderSeatBagInfo: "Je boeking bevat één handbagage.",
        optionsFlightLuggageUnderSeatBagInfoMaxSize: "Maximale afmeting: 40x30x20 cm",
        optionsFlightAdditionalLuggage: "Extra bagage",
        optionsLuggagePopupTitle: "Reist u zonder bagage?",
        optionsLuggagePopupDescription: "Het lijkt erop dat u geen bagage aan uw boeking heeft toegevoegd. Voor een vliegpakket kan dit onhandig zijn.\n\nWilt u doorgaan zonder bagage of nu wat toevoegen?",
        optionsLuggagePopupNoLuggage: "Ik wil geen bagage",
        optionsLuggagePopupAddLuggage: "Ik wil bagage toevoegen",
        optionParking: "Parking",
        optionsParkingDefault: "Parkeerplaats",
        // Transport cabin translations
        transportSharedCabinTitle: "1-persoonsbed in gedeelde coupé",

        transportSharedCabinDescription: "Beleef een unieke reiservaring in een 1-persoonsbed in gedeelde coupé.",
        transportPrivateCabinTitleSingle: "Privé hut 6 plaatsen",
        transportPrivateCabinTitlePlural: "Privé hutten 6 plaatsen",
        transportPrivateCabinDescription: "Reserveer een volledige privé hut, alleen of met anderen, voor je familie- of vriendenreis.",
        transportDetailBannerDescription: "Elke coupé heeft zes 1-persoonsbedden voor een rustige nacht.",
        transportDetailBannerDetails: "Details",
        transportDetailSharedCabinDescription: "Elke gedeelde coupé is ontworpen als een warme, intieme en comfortabele ruimte waar families en vrienden samenkomen om te delen, uit te wisselen en samen te dromen over de momenten die hen te wachten staan.",
        transportDetailSharedCabinFooterTitle: "Reis alleen met vrouwen",
        transportDetailSharedCabinFooterDescription: "We hebben een 100% vrouwelijke ruimte voorbereid voor een rustige reis.",
        transportDetailPrivateCabinDescription: "Een privé hut reserveer je eenvoudig, voor gezinnen en groepen of wanneer je vooral rustig wilt reizen.",
        transportCriteriaWifi: "Gratis Wi-fi",
        transportCriteriaBar: "Bar wagon",
        transportCriteriaOutlet: "Stopcontact",
        transportCriteriaPillow: "Laken, slaapzak, kussensloop en deken inbegrepen.",
        transportCriteriaComfortPouch: "Comfort tasje (verfrissende doekjes, oordopjes, tissues)",
        transportCriteriaPrivateSpace: "Privé ruimte",
        transportCriteriaPlaces: "6 1-persoonsbedden",
        transportOnlyWomenTitle: "Vrouwen-only ruimte (gratis)",
        transportOnlyWomenDescription: "Een ruimte gereserveerd voor vrouwen om 's nachts in alle rust te reizen.",
        transportPreferencesAvailabilityNotice: "*Jouw voorkeuren worden meegenomen afhankelijk van beschikbaarheid",
        transportFullTimelineTitle: "Reis details",
        transportDetailPanelTitle: "Een comfortabele reis",
        optionsTrainOnly: "Trein",
        // Transfer translations
        unicular: "Funiculaire",
        transferBusDescription: "Een gedeelde shuttle met vaste tijden en meerdere stopplaatsen. Buswissels of lopen kunnen nodig zijn.",
        transferBusLesArcsTitle: "Shuttle",
        transferBusLesArcsDescription: "Een gedeelde shuttle met vaste tijden en meerdere stopplaatsen. Buswissels of lopen kunnen nodig zijn.",
        transferTaxiDescription: "Een privé-transfer met een gedelegeerde chauffeur voor uw exclusieve gebruik.",
        transferUnicularDescription: "Bereik Les Arcs gemakkelijk dankzij de ultramoderne funiculaire, die het station van Bourg-Saint-Maurice verbindt met het station Les Arcs 1600 in slechts 7 minuten.",
        transferCriteriaDuration: "Geschatte transfertijd:",
        transferCriteriaWalking: "Kan buswissels onderweg vereisen of lopen naar uw verblijf.",
        transferUnicularCriteriaWalking: "Op het aankomststation van de funiculaire vindt u shuttles naar andere Les Arcs-stations (Les Arcs 1800, Les Arcs 1950 en Les Arcs 2000)",
        transferCriteriaDoorToDoor: "Deur-tot-deur service",
    },
    "optin": {
        "common": {
            "seeMore": "Meer weergeven",
            "seeLess": "Minder weergeven",
            "clickHere": "klik hier",
            "reserve": "Reserveren"
        },
        "terms": {
            "label": `Ik heb gelezen en accepteer de <a href='${cgvUrl}' target='_blank'><strong>Algemene Voorwaarden</strong></a>, de informatiedocumenten, de algemene en bijzondere verkoopvoorwaarden voor verzekeringen en het <a href='${privacyPolicyLink}' target='_blank'><strong>Beleid voor het beheer van persoonsgegevens</strong></a>.`,
            "short": "De verzamelde gegevens worden verwerkt door de onderneming Travelfactory, die verantwoordelijk is voor de verwerking en waarvan het hoofdkantoor is gevestigd op 19 rue Emmy Noether, 93400 Saint-Ouen, Frankrijk. <br/>",
            "full": `Deze gegevens zijn essentieel voor het beheren van uw reservering en het afsluiten van het bijbehorende contract. Ze worden opgenomen in de database van Travelfactory en tevens gebruikt om u informatie en advertenties te sturen over vergelijkbare producten en diensten, op basis van ons gerechtvaardigd belang en de wettelijke bepalingen met betrekking tot commerciële prospectie. U heeft rechten met betrekking tot uw gegevens, die u kunt uitoefenen via ons contactformulier <a href='${dataRightsLink}' target='_blank'>hier</a>. Voor meer informatie over de verwerking van uw gegevens, raadpleeg ons <a href='${privacyPolicyLink}' target='_blank'>beleid voor de bescherming van persoonsgegevens</a>. U kunt zich op elk moment afmelden via een link in de elektronische nieuwsbrieven of per e-mail.`
        },
        "description": {
            "short": "Als je geen informatie van ons wilt ontvangen, <span class='underline'>klik hier</span>.",
            "email": "Email",
            "sms": "SMS",
            "note": "Als je de vakjes uitvinkt, maak je bezwaar tegen het ontvangen van commerciële communicatie. Je kunt nog steeds berichten ontvangen die strikt noodzakelijk zijn om je verblijf te voltooien. (bijv. boekingsbevestiging, betalingsherinnering)."
        }
    },
    "food": {
        "foodImageCriteria1025": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_new.jpg",
        "foodImageCriteria1025Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_mobile_new.jpg",
        "foodImageCriteria10241025": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_halal_new.jpg",
        "foodImageCriteria10241025Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_enfant_halal_mobile_new.jpg",
        "foodImageCriteria1023": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_new.jpg",
        "foodImageCriteria1023Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_mobile_new.jpg",
        "foodImageCriteria1024": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal.jpg",
        "foodImageCriteria1024Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal_mobile_new.jpg",
        "foodImageCriteria10231024": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal.jpg",
        "foodImageCriteria10231024Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gourmand_halal_mobile_new.jpg",
        "foodImageCriteria1021": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gastronomique_new.jpg",
        "foodImageCriteria1021Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_gastronomique_mobile.jpg",
        "foodImageCriteria1067": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_petit_dejeuner.png",
        "foodImageCriteria1067Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_petit_dejeuner_mobile.png",
        "foodImageCriteria1069": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_demi_pension.png",
        "foodImageCriteria1069Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.travelski.com/images/panier_demi_pension_mobile.png",
        "foodImageCriteria1071": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course dinner menu 6 days_desktop.png",
        "foodImageCriteria1071Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course dinner menu 6 days_mobile.png",
        "foodImageCriteria1072": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course vegetarian menu 3 days Desktop.png",
        "foodImageCriteria1072Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course vegetarian menu 3 days Mobile.png",
        "foodImageCriteria1073": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course vegetarian menu 6 days Desktop.png",
        "foodImageCriteria1073Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course vegetarian menu 6 days Mobile.png",
        "foodImageCriteria1074": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/vegan dinner only 3 days_desktop.png",
        "foodImageCriteria1074Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/vegan dinner only menu 3 days_mobile.png",
        "foodImageCriteria1075": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/vegan dinner only 6 days_desktop.png",
        "foodImageCriteria1075Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/vegan dinner only menu 6 days_mobile.png",
        "foodImageCriteria1076": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Kids menu 3 days_desktop.png",
        "foodImageCriteria1076Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Kids menu 3 days_mobile.png",
        "foodImageCriteria1077": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Kids menu 6 days_desktop.png",
        "foodImageCriteria1077Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Kids menu 6 days_mobile.png",
        "foodImageCriteria1078": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course dinner menu 3 days_desktop.png",
        "foodImageCriteria1078Mobile": "https://d2g8cl15vz3wxd.cloudfront.net/migdal/page/https://www.uk.travelski.com/images/Three course dinner menu 3 days_mobile.png"
    },
    "globalInsuranceConditions": "Bekijk de voorwaarden van de verzekering"


};


export default optionsNlTranslations;

